"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
/**
 * The standard framework message bus
 *
 * Internally uses Rxjx to broadcast the messages
 */
class MessageBus {
    static emit(message) {
        return new Promise((resolve, reject) => {
            var _a;
            const eventName = message.getSubject();
            // find the subject for the event name
            const subject = (_a = this.subjects[eventName]) !== null && _a !== void 0 ? _a : null;
            if (subject === null) {
                resolve(null);
                return;
            }
            // register a reply subject for two-way communication
            const replySubject = new rxjs_1.Subject();
            replySubject.subscribe({
                next(result) {
                    resolve(result);
                },
                error(err) {
                    reject(err);
                }
            });
            // send the message to the subject
            subject.next({ message, replySubject });
        });
    }
    /**
     * Listen for message of a specific type. If the handler returns a promise a reply will be send to the sender
     */
    static observe(messageConstructor, handler) {
        var _a;
        const eventName = String(messageConstructor.prototype.getSubject());
        // find the subject for the event name
        const subject = this.subjects[eventName] = (_a = this.subjects[eventName]) !== null && _a !== void 0 ? _a : new rxjs_1.Subject();
        // register the handler for the subject, and return the subscription
        return subject.subscribe((message) => {
            const response = handler(message.message);
            MessageBus.handleObserveResult(response, message.replySubject);
        });
    }
    static reset() {
        this.subjects = {};
    }
    /**
     * If result is promise, send reply on success, or error on failure
     */
    static handleObserveResult(result, replySubject) {
        if (result instanceof Promise) {
            result.then((val) => {
                replySubject.next(val);
                replySubject.complete();
            }).catch(() => {
                replySubject.error(null);
                replySubject.complete();
            });
        }
        else {
            replySubject.next(result);
            replySubject.complete();
        }
    }
}
MessageBus.subjects = {};
exports.default = MessageBus;
//# sourceMappingURL=MessageBus.js.map